// extracted by mini-css-extract-plugin
export default {"addText":"InlineTextEditor_addText__hOmdd"};